import React from "react";

export const CompareStocksdrpData = [
  { title: "Consolidated", value: "consol" },
  { title: "Standalone", value: "stand" },
];

export const pricesizeColumnsArray = [
  { columnName: "Price", key: "price" },
  { columnName: "Market Cap (Cr)", key: "marketCap" },
  { columnName: "Size", key: "size" },
];

export const morningStarColumnsArray = [
  { columnName: "Morning Star Rating", key: "morningStarRating" },
];

export const annulaisedReturnsColumnsArray = [
  { columnName: "1 month", key: "month1" },
  { columnName: "3 months", key: "month3" },
  { columnName: "6 months", key: "month6" },
  { columnName: "1 Yr", key: "year1" },
  { columnName: "3 Yr", key: "year3" },
  { columnName: "5 Yr", key: "year5" },
  /* { columnName: "10 Yr", key: "10yr" }, */
];
export const returnsComparisionColumnsArray = (year: any) => [
  { columnName: `Jan-Dec ${year}`, key: `jan-dec ${year}` },
  { columnName: "Fund Return", key: "fundReturn" },
  { columnName: "Category Average Return", key: "categoryAverageReturn" },
  { columnName: "Alpha", key: "alpha" },
];

export const ristMeasuresColumnsArray = [
  {
    columnName: "Sharpe Ratio",
    key: "sharpeRatio",
    tdCustomFunction: (key: any) => {
      return "NA";
    },
  },
  {
    columnName: "R Shaped Ratio",
    key: "rShapedRatio",
    tdCustomFunction: (key: any) => {
      return "NA";
    },
  },
  {
    columnName: "Beta Ratio",
    key: "betaRatio",
    tdCustomFunction: (key: any) => {
      return "NA";
    },
  },
  {
    columnName: "Correlation Ratio",
    key: "coRelationRation",
    tdCustomFunction: (key: any) => {
      return "NA";
    },
  },
  { columnName: "Fund Risk Grade", key: "fundRiskGrade" },
];
export const investmentDetailsColumnsArray = [
  { columnName: "Min Lumpsum Investment", key: "minLumpsumInvestment" },
  { columnName: "Min SIP Investment", key: "minSIPInvestment" },
];
export const withDrawalDetailsColumnsArray = [
  { columnName: "Lock In Period", key: "lockInPeriod" },
  {
    columnName: "Exit Load",
    key: "exitLoad",
    tdCustomFunction: (key: any) => {
      return !key.length
        ? "NA"
        : key.map((el: any, i: number) => {
            return (
              <div key={i}>
                {el?.period ? el.period : "-"} -{" "}
                {el?.exitLoad ? el.exitLoad + "%" : "-"}
              </div>
            );
          });
    },
  },
  { columnName: "Tax Implications", key: "taxImplications" },
];
export const stockCompositionColumnsArray = [
  { columnName: "Stock Composition", key: "stockComposition" },
  /* {
    columnName: "Break Up of market capitalization",
    key: "breakUpOfMarketCapitalization",
  },
  { columnName: "Top Sector Holding", key: "topSectorHolding" },
  { columnName: "Top 5 Holding", key: "top5Holding" },
  { columnName: "Top 5 Holding", key: "top5Holding" }, */
];
export const breakUpOfMarketCapitalization = [
  {
    columnName: "Break Up of market capitalization",
    key: "breakUpOfMarketCapitalization",
  },
];
export const topSectorHolding = [
  {
    columnName: "Top Sector Holding",
    key: "topSectorHolding",
  },
];
export const numberOfScrips = [
  {
    columnName: "Number of Scrips",
    key: "numberOfScrips",
  },
];
export const top5Holding = [
  {
    columnName: "Top 5 Holding",
    key: "top5Holding",
  },
];

export const schemeDetailsColumnsArray = [
  { columnName: "Category", key: "category" },
  { columnName: "Sub Category", key: "subCategory" },
  { columnName: "AUM", key: "aum" },
  { columnName: "Launch Date", key: "launchDate" },
  { columnName: "Fund Manager Name", key: "fundManagerName" },
  { columnName: "Fund Manager Since", key: "fundManagerSince" },
  /* { columnName: "Investment Style", key: "investmentStyle" }, */
  { columnName: "Scheme Type", key: "schemeType" },
  { columnName: "Benchmark", key: "benchmark" },
  { columnName: "Expense Ratio", key: "expenseRatio" },
  { columnName: "Open ended/Close ended", key: "openEndedORCloseEnded" },
];

export const returnColumnsArray = [
  { columnName: "1 Week", key: "oneWeek" },
  { columnName: "1 Month", key: "oneMonth" },
  { columnName: "3 Months", key: "threeMonths" },
  { columnName: "6 Months", key: "sizMonths" },
  { columnName: "1 Year", key: "oneYear" },
  { columnName: "3 Year", key: "threeYears" },
  { columnName: "5 Year", key: "fiveYears" },
];
export const PerShareDataColumnsArray = [
  { columnName: "Earnings Per Share (TTM)", key: "epsPerShare" },
  { columnName: "Dividend Per Share (TTM)", key: "dividendPerShare" },
  { columnName: "Book Value Per Share (TTM)", key: "bookValuePerShare" },
  {
    columnName: "Face Value (TTM)",
    key: "faceValue",
  },
];
export const PerShareAnnualDataColumnsArray = [
  { columnName: "Earnings Per Share", key: "earningsPerShare" },
  { columnName: "Dividend Per Share", key: "dividendPerShare" },
  {
    columnName: "EPS After Minority Interest Adjusted",
    key: "epsAfterMinorityInterestAdj",
  },
  {
    columnName: "Face Value",
    key: "faceValue",
  },
];

export const GrowthRatiosColumnsArray = (year: any) => [
  { columnName: year, key: "priceToEarnings" },
];
export const ValuationRatioPriceToEarningsColumnsArray = (year: any) => [
  { columnName: year, key: "priceToEarnings" },
];
export const ValuationRatioEnterpriseValueToEbtidaColumnsArray = (
  year: any,
) => [{ columnName: year, key: "enterpriseValueToEbtida" }];
export const ValuationRatioEnterpriseValueToSalesColumnsArray = (year: any) => [
  { columnName: year, key: "enterpriseValueToSales" },
];
export const ValuationRatioPriceToBookValueColumnsArray = (year: any) => [
  { columnName: year, key: "priceToBookValue" },
];
export const ValuationRatiosTTMColumnsArray = () => [
  { columnName: "EV Ebtida", key: "evEbitdaTTM" },
  { columnName: "EV Sales", key: "evSalesTTM" },
  { columnName: "PBV", key: "pbvTTM" },
  { columnName: "PE Ratio", key: "peRatioTTM" },
];
export const GrowthRatioRevenueGrowthColumnsArray = (year: any) => [
  { columnName: year, key: "revenueGrowth" },
];
export const GrowthRatioNetInterestIncomeColumnsArray = (year: any) => [
  { columnName: year, key: "netInterestIncomeGrowth" },
];
export const GrowthRatioBankNetIncomeGrowthColumnsArray = (year: any) => [
  { columnName: year, key: "totalIncome" },
];
export const GrowthRatioEbtidaGrowthColumnsArray = (year: any) => [
  { columnName: year, key: "ebtidaGrowth" },
];
export const GrowthRatioEbitGrowthColumnsArray = (year: any) => [
  { columnName: year, key: "ebitGrowth" },
];
export const GrowthRatioPbtGrowthColumnsArray = (year: any) => [
  { columnName: year, key: "pbtGrowth" },
];
export const GrowthRatioNetIncomeGrowthColumnsArray = (year: any) => [
  { columnName: year, key: "netIncomeGrowth" },
];
export const GrowthRatioRevenue3YrCAGRGrowthColumnsArray = (year: any) => [
  { columnName: year, key: "revenue3YrCAGRGrowth" },
];
export const GrowthRatioEbtida3YrCAGRGrowthColumnsArray = (year: any) => [
  { columnName: year, key: "ebtida3YrCAGRGrowth" },
];
export const GrowthRatiosTTMColumnsArray = () => [
  { columnName: "Growth Per YOY EBIT", key: "growthPerYoyEbitTTM" },
  { columnName: "Growth Per YOY EBITDA", key: "growthPerYoyEbitdaTTM" },
  { columnName: "Growth Per YOY Net Profit", key: "growthPerYoyNetProfitTTM" },
  {
    columnName: "Growth Per YOY Profit Before Tax",
    key: "growthPerYoyProfitBeforeTaxTTM",
  },
  {
    columnName: "Growth Per YOY Profit After Tax",
    key: "growthPerYoyReportedProfitAfterTaxTTM",
  },
  { columnName: "Growth Per YOY Sales", key: "growthPerYoysalesTTM" },
];
export const MarginRatioEBTIDAMarginsColumnsArray = (year: any) => [
  { columnName: year, key: "ebtidaMargin" },
];
export const MarginRatioEBITMarginsColumnsArray = (year: any) => [
  { columnName: year, key: "ebitMargin" },
];
export const MarginRatioNetProfitMarginsColumnsArray = (year: any) => [
  { columnName: year, key: "netProfitMargin" },
];
export const MarginRatioBankInterestExpendedEarnedColumnsArray = (
  year: any,
) => [{ columnName: year, key: "interestExpendedEarned" }]; ////////////
export const MarginRatioTotalProfitColumnsArray = (year: any) => [
  { columnName: year, key: "totalOperExpToTotalIncome" },
];
export const MarginRatioNIMToTotalIncomeColumnsArray = (year: any) => [
  { columnName: year, key: "nimToTotalIncome" },
]; ///////////////////
export const MarginRatioNetProfitColumnsArray = (year: any) => [
  { columnName: year, key: "totalOperExpToTotalIncome" },
];
export const MarginTTMColumnsArray = () => [
  { columnName: "Margin Per Adj Profit", key: "marginPerAdjProfit" },
  { columnName: "Margin Per Ebit", key: "marginPerEbit" },
  { columnName: "Margin Per Ebitda", key: "marginPerEbitda" },
  {
    columnName: "Margin Per Rpat",
    key: "marginPerRpat",
  },
];
export const marginPerEbitda = [
  {
    columnName: "TTM",
    key: "marginPerEbitda",
  },
];
export const marginPerEbit = [
  {
    columnName: "TTM",
    key: "marginPerEbit",
  },
];
export const marginPerAdjProfit = [
  {
    columnName: "TTM",
    key: "marginPerAdjProfit",
  },
];
export const interestExpendedEarned = [
  {
    columnName: "TTM",
    key: "interestExpendedEarned",
  },
];
export const nimToTotalIncome = [
  {
    columnName: "TTM",
    key: "nimToTotalIncome",
  },
];
export const perOfTotalIncome = [
  {
    columnName: "TTM",
    key: "perOfTotalIncome",
  },
];

export const peRatioTTM = [
  {
    columnName: "TTM",
    key: "peRatioTTM",
  },
];
export const evEbitdaTTM = [
  {
    columnName: "TTM",
    key: "evEbitdaTTM",
  },
];
export const evSalesTTM = [
  {
    columnName: "TTM",
    key: "evSalesTTM",
  },
];
export const pbvTTM = [
  {
    columnName: "TTM",
    key: "pbvTTM",
  },
];

export const growthPerYoyEbitTTM = [
  {
    columnName: "TTM",
    key: "growthPerYoyEbitTTM",
  },
];
export const growthPerYoyEbitdaTTM = [
  {
    columnName: "TTM",
    key: "growthPerYoyEbitdaTTM",
  },
];
export const growthPerYoyProfitBeforeTaxTTM = [
  {
    columnName: "TTM",
    key: "growthPerYoyProfitBeforeTaxTTM",
  },
];
export const growthPerYoyNetProfitTTM = [
  {
    columnName: "TTM",
    key: "growthPerYoyNetProfitTTM",
  },
];
export const growthPerYoysalesTTM = [
  {
    columnName: "TTM",
    key: "growthPerYoysalesTTM",
  },
];
export const netInterestIncomeTTM = [
  {
    columnName: "TTM",
    key: "netInterestIncomeTTM",
  },
];
export const totalIncomeTTM = [
  {
    columnName: "TTM",
    key: "totalIncomeTTM",
  },
];

export const epsAfterMinorityInterestAdj = [
  {
    columnName: "TTM",
    key: "epsAfterMinorityInterestAdj",
  },
];
export const dividendPerShare = [
  {
    columnName: "TTM",
    key: "dividendPerShare",
  },
];
export const bookValuePerShare = [
  {
    columnName: "TTM",
    key: "bookValuePerShare",
  },
];
export const faceValue = [
  {
    columnName: "TTM",
    key: "faceValue",
  },
];

export const PerShareEPSAdjustedColumnsArray = (year: any) => [
  { columnName: year, key: "epsAfterMinorityInterestAdj" },
];
export const DividendPerShareColumnsArray = (year: any) => [
  { columnName: year, key: "dividendPerShare" },
];
export const BookValuePerShareColumnsArray = (year: any) => [
  { columnName: year, key: "bookValuePerShare" },
];
export const FaceValuePerShareColumnsArray = (year: any) => [
  { columnName: year, key: "faceValue" },
];

export const ReturnsRatioROEColumnsArray = (year: any) => [
  { columnName: year, key: "returnOnEquity" },
];
export const ReturnsRatioROAColumnsArray = (year: any) => [
  { columnName: year, key: "returnOnAssets" },
];
export const LevarageRatioDebtToEquityColumnsArray = (year: any) => [
  { columnName: year, key: "debtToEquity" },
];
export const LevarageRatioNetDebtToEquityColumnsArray = (year: any) => [
  { columnName: year, key: "netDebtToEquity" },
];
export const LevarageRatioInterestCoverageRatioColumnsArray = (year: any) => [
  { columnName: year, key: "interestCoverageRatio" },
];
export const CashCycleRatioInventoryTurnOverColumnsArray = (year: any) => [
  { columnName: year, key: "inventoryTurnoverRatio" },
];
export const CashCycleRatioDebtorTurnOverColumnsArray = (year: any) => [
  { columnName: year, key: "debtorsTurnoverRatio" },
];
export const CashCycleRatioCreditorTurnOverColumnsArray = (year: any) => [
  { columnName: year, key: "fixedAssetTurnoverRatio" },
];
export const ShareHoldingPromotorHoldingColumnsArray = (year: any) => [
  { columnName: year, key: "promoterHolding" },
];
export const ShareHoldingPromotorPledgeColumnsArray = (year: any) => [
  { columnName: year, key: "promoterPledge" },
];
export const ShareHoldingMFHoldingColumnsArray = (year: any) => [
  { columnName: year, key: "mfHolding" },
];
export const ShareHoldingFIIHoldingColumnsArray = (year: any) => [
  { columnName: year, key: "fllHolding" },
];
export const TechnicalAnalysisCMPAboveOrBelowFromEMAAndSMAColumnsArray = (
  day: any,
) => [{ columnName: day + +"Days", key: "value" }];

export const months = [
  { title: "January", value: "1" },
  { title: "February", value: "2" },
  { title: "March", value: "3" },
  { title: "April", value: "4" },
  { title: "May", value: "5" },
  { title: "June", value: "6" },
  { title: "July", value: "7" },
  { title: "August", value: "8" },
  { title: "September", value: "9" },
  { title: "October", value: "10" },
  { title: "November", value: "11" },
  { title: "December", value: "12" },
];

export const scanDataColumn = [
  {
    columnName: "",
    key: "years",
  },
  {
    columnName: "Positive",
    key: "Positive",
  },
  {
    columnName: "Negative",
    key: "Negative",
  },
];

export const TechnicalAnalysisCMPFromEMAAndSMAColumnsArray = [
  { columnName: "5 days", key: "5days" },
  { columnName: "10 Days", key: "10days" },
  { columnName: "12 Days", key: "12days" },
  { columnName: "20 Days", key: "20days" },
  { columnName: "26 Days", key: "26days" },
  { columnName: "50 Days", key: "50days" },
  { columnName: "100 Days", key: "100days" },
  { columnName: "200 Days", key: "200days" },
];

export const TechnicalAnalysisIndicatorsColumnsArray = [
  //{ columnName: "RSI", key: "rsi" },
  { columnName: "MFI", key: "msi" },
  { columnName: "CCI", key: "cci" },
  { columnName: "Williams %R", key: "williams%R" },
  { columnName: "MCAD (12,26,9)", key: "MCAD(12,26,9)" },
  { columnName: "MCAD Signal", key: "MCADSignal" },
  { columnName: "ROC (21)", key: "ROC(21)" },
  { columnName: "ROC (125)", key: "ROC(125)" },
  //{ columnName: "Sochastics", key: "sochastics" },
  { columnName: "ATR", key: "atr" },
  { columnName: "ADX", key: "adx" },
];
export const PeerComparisionDataArray = [
  "Hero Motorcorp",
  "Eicher Motors",
  "Hyundai Motors",
  "TVS Motor Co.",
  "Hind Motors",
  "Hero Motorcorp",
  "Eicher Motors",
  "Hyundai Motors",
  "TVS Motor Co.",
  "Hind Motors",
  "Hero Motorcorp",
  "Eicher Motors",
  "Hyundai Motors",
  "TVS Motor Co.",
  "Hind Motors",
];

export enum QuoteTypes {
  CORP_FD_QUOTE = "CORP_FD_QUOTE",
  EQUITY_QUOTE = "EQUITY_QUOTE",
  ETF_QUOTE = "ETF_QUOTE",
  FUTURES_QUOTE = "FUTURES_QUOTE",
  INDEX_FUNDS_QUOTE = "INDEX_FUNDS_QUOTE",
  INDICES_QUOTE = "INDICES_QUOTE",
  IPO_QUOTE = "IPO_QUOTE",
  MUTUAL_FUNDS_QUOTE = "MUTUAL_FUNDS_QUOTE",
  NCD_QUOTE = "NCD_QUOTE",
  NCD_IPO_QUOTE = "NCD_IPO_QUOTE",
  NFO_QUOTE = "NFO_QUOTE",
  OPTIONS_QUOTE = "OPTIONS_QUOTE",
  ncdExchanheQuoteLinks = "ncdExchanheQuoteLinks",
  OPTIONS_NCDEXCHANGE = "OPTIONS_NCDEXCHANGE",
  OPTIONS_NCDIPO = "OPTIONS_NCDIPO",
}
